import { render } from "./RegisterHistory.vue?vue&type=template&id=e551b0ba&scoped=true&ts=true"
import script from "./RegisterHistory.vue?vue&type=script&lang=ts"
export * from "./RegisterHistory.vue?vue&type=script&lang=ts"

import "./RegisterHistory.vue?vue&type=style&index=0&id=e551b0ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e551b0ba"]])

export default __exports__